import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import {
  FeaturesConfig, I18nConfig, OccConfig,
  provideConfig,
  SiteContextConfig
} from '@spartacus/core';
import {
  defaultB2bCheckoutConfig,
  defaultB2bOccConfig
} from '@spartacus/setup';
import { defaultCmsContentProviders, mediaConfig, OutletPosition, provideOutlet } from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { LayoutConfigModule } from '../layout/layout-config';
import { CartItemListEkComponent } from './commonComponents/cart/shared/cart-item-list/cart-item-list.component';
import { CheckoutOrderListComponent } from './commonComponents/checkout/checkout-order-list/checkout-order-list.component';
import { HeaderComponent } from './commonComponents/header/header.component';

@NgModule({
  declarations: [],
  imports: [LayoutConfigModule],
  providers: [provideConfig(mediaConfig), ...defaultCmsContentProviders, provideConfig(<OccConfig>{
    backend: {
      occ: {
        baseUrl: environment.occBaseUrl,
      },
    },
  }),
  provideOutlet({
    id: 'cx-header',
    position: OutletPosition.REPLACE,
    component: HeaderComponent,
  }),
  provideOutlet({
    id: 'cx-cart-item-list',
    position: OutletPosition.REPLACE,
    component: CartItemListEkComponent,
  }),
  provideOutlet({
    id: 'cx-review-submit',
    position: OutletPosition.REPLACE,
    component: CheckoutOrderListComponent,
  }),


  provideConfig(<SiteContextConfig>{
    context: {
      // TODO: adjust parameters and site
      urlParameters: ['baseSite', 'language', 'currency'],
      baseSite: ['lipton-us','lipton-pk'],//baseSite: ['ekaterraPK'],
      currency: ['USD','PKR'],//currency: ['USD','PK'],
      language: ['en'],
    },
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      backend: {
        loadPath: '/assets/i18n/{{lng}}/{{ns}}.json',
      },
      chunks: translationChunksConfig,
    },
  }),
  provideConfig(<FeaturesConfig>{
    features: {
      level: '4.1',
    },
  }),
  provideConfig(<OccConfig>{
    backend: {
      occ: {
        baseUrl: environment.occBaseUrl,
      },
    },
  }),
  provideConfig(<SiteContextConfig>{
    context: {
      currency: ['USD','PKR'],//currency: ['USD',PK],
      language: ['en'],
    },
  }),
  provideConfig(<FeaturesConfig>{
    features: {
      level: '4.3',
    },
  }),
  provideConfig(defaultB2bOccConfig),
  provideConfig(defaultB2bCheckoutConfig),
  ],
})
export class SpartacusConfigurationModule { }
